// extracted by mini-css-extract-plugin
module.exports = {"action":"link_action__FLATp","icon":"link_icon___A7Z0"};